import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';
import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import SuspenseLoader from 'src/components/SuspenseLoader';
import portalRoutes from 'src/content/applications/ClientPortal';
import TenantRouteRedirect from 'src/components/TenantRouteRedirect';
import TenantAutoRedirect from 'src/components/TenantAutoRedirect';


const Loader = (Component) => (props) =>
(
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// Converted Static Imports
const PersonSlide = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/Components/PersonSlide')));
// --- Project Management ---
const Projects = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/Projects')));
const AddProjects = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/Projects/AddProjects')));
const ViewProject = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/Projects/ViewProjects')));
const ClientTable = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/Client/ClientTable')));
const AddClient = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/Client/addClient')));
const ViewClient = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/Client/viewClient')));
const ClientDetails = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/Client/ClientDetails')));

// --- Core Auth & Settings ---
const NotificationsPage = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/layouts/SidebarLayout/Header/Buttons/Notifications/notificationPage')));
const AddUsers = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AddUsers')));

// --- Employee / User Management ---
const MyDetailsInfo = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/MyDetailsInfo')));
const MyDetails = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/MyDetails')));
const Employees = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/MyDetails/Employees')));
const MyDetail = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/MyDetails/MyDetail')));
const EmployeeDirectory = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/employee-directory')));
const EmployeeListV2 = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/EmployeeListV2')));
const EmployeeProfilePage = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/EmployeeProfile')));
const UserProfile = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Users/profile')));
const UserSettings = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Users/settings')));
const MyProfile = Loader(lazy(() => import(/* webpackChunkName: "user-profile-app" */ 'src/content/applications/UserProfile/UserProfile')));
const AddEmployeeRds = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/MyDetails/addEmployeeRds')));
const AddEmployee = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/MyDetails/AddEmployee')));
const EmployeeList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/MyDetails/EmployeeListTable')));
const UserDetailsEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/User-Details/ViewUser')));
const UserView = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/User-Details/Users/detailViewUser')));
const UserDetails = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/User-Details/AddUser')));
const UserDetailsList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/User-Details/Users')));
const UserDetailPage = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Users/UserDetailPage')));
// --- Ticket & Support Module ---
const Tickets = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Tickets')));
const AddTickets = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Tickets/AddTickets')));
const TicketTool = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Tickettool/Tickettool')));
const AddTicketTool = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Tickettool/AddTickettool')));
const ViewTicketTool = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Tickettool/ViewTickettool')));
const EditTicketTool = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Tickettool/EditTickettool')));
const TickettoolApp = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Tickettool')));
// --- Resignation Module ---
const Resignationsubmission = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/ResignationSubmission/index')));
const ResignationEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ResignationSubmission/ResignationEdit')));
const AddResignation = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ResignationSubmission/AdminAddResignation')));
const ResignationApproval = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ResignationSubmission/ResignationApprove')));
const ExitInterview = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ResignationSubmission/ExitInterview')));

// --- Asset Management Module ---
const AssetDetails = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetDetails/AssetDetails')));
const AssetDetailsEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetDetails/AssetDetailsEdit')));
const AssetManagementList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetDetails/AssetDetailsList')));
const AssetUtilize = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetUtilize/AssetUtilize')));
const AssetUtilizeList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetUtilize/AssetUtilizeList')));
const AssetUtilizeEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetUtilize/AssetUtilizeEdit')));
const AssetService = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetService/AssetService')));
const AssetSeviceEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetService/AssetServiceEdit')));
const AssetServiceList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetService/AssetServiceList')));
const AssetExitForm = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetExitForm/AssetExitForm')));
const AssetExitEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetExitForm/AssetExitEdit')));
const AssetExitFormList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetExitForm/AssetExitFormList')));
const AssetProfile = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/AssetManagement/AssetProfile/AssetProfile')));

// --- Workflow V2 Module ---
const WorkflowDashboard = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Dashboard').then(module => ({ default: module.Dashboard }))));
const WorkflowBoard = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Board').then(module => ({ default: module.TaskBoard }))));
const WorkflowNewTask = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Tasks/NewTask').then(module => ({ default: module.NewTask }))));
const WorkflowTasksList = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Tasks').then(module => ({ default: module.TasksList }))));
const WorkflowViewTask = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Tasks/ManageTask').then(module => ({ default: module.ManageTask }))));
const WorkflowEditTask = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Tasks/EditTask').then(module => ({ default: module.EditTask }))));
const WorkflowCreate = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Workflows/CreateWorkflow').then(module => ({ default: module.CreateWorkflow }))));
const WorkflowsList = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Workflows/WorkflowsList').then(module => ({ default: module.WorkflowsList }))));
const ViewWorkflow = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Workflows/ViewWorkflow').then(module => ({ default: module.ViewWorkflow }))));
const WorkflowTemplateCreate = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Templates/CreateTemplate').then(module => ({ default: module.CreateTemplate }))));
const WorkflowTemplateEdit = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Templates/EditTemplateWrapper').then(module => ({ default: module.EditTemplateWrapper }))));
const WorkflowTemplates = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Templates').then(module => ({ default: module.Templates }))));
const WorkflowChecklistCreate = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Checklists/CreateChecklist').then(module => ({ default: module.CreateChecklist }))));
const WorkflowChecklists = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Checklists').then(module => ({ default: module.Checklists }))));
const WorkflowLabels = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Labels')));
const WorkflowCalendar = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Calendar').then(module => ({ default: module.Calendar }))));
const ComplianceTemplates = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/pages/WorkflowV2/Compliance').then(module => ({ default: module.ComplianceTemplatesPage }))));
const ComplianceTemplateDetail = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/pages/WorkflowV2/Compliance').then(module => ({ default: module.ComplianceTemplateDetail }))));
const ClientComplianceProfiles = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/pages/WorkflowV2/Compliance').then(module => ({ default: module.ClientComplianceProfilesPage }))));
const ProcessBindings = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/pages/WorkflowV2/Compliance').then(module => ({ default: module.ProcessBindingsPage }))));
const ComputedDeadlines = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/pages/WorkflowV2/Compliance').then(module => ({ default: module.ComputedDeadlinesPage }))));
const ClientComplianceDashboard = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/pages/WorkflowV2/Compliance').then(module => ({ default: module.ClientComplianceDashboard }))));
const CustomFieldsExample = Loader(lazy(() => import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/Examples/CustomFieldsExample')));
const PMDashboard = Loader(
    lazy(() =>
        import(/* webpackChunkName: "workflow-v2-app" */ 'src/content/applications/WorkflowV2/PMDashboard').then(
            (module) => ({ default: module.PMDashboard })
        )
    )
);

// --- SOP Module Routes (NEW) ---
const SOPDocuments = Loader(lazy(() => import(/* webpackChunkName: "sop-app" */ 'src/pages/SOP').then(module => ({ default: module.SOPDocumentsPage }))));
const SOPViewPage = Loader(lazy(() => import(/* webpackChunkName: "sop-app" */ 'src/pages/SOP/SOPViewPage').then(module => ({ default: module.SOPViewPage }))));
const SOPCreatePage = Loader(lazy(() => import(/* webpackChunkName: "sop-app" */ 'src/pages/SOP/SOPCreatePage').then(module => ({ default: module.SOPCreatePage }))));

// --- Workflow Services Module (NEW) ---
const ServiceCatalog = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services')));
const ServiceDetail = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services/ServiceDetail')));
const ServiceForm = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services/ServiceForm')));
const ClientServicesPage = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services/ClientServices')));
const ClientServiceForm = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services/ClientServiceForm')));
const ClientServiceDetail = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services/ClientServiceDetail')));
const ProjectDetails = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services/ProjectDetails')));
const ScheduledJobsPage = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services/ScheduledJobs')));
const ServiceSettingsPage = Loader(lazy(() => import(/* webpackChunkName: "workflow-services-app" */ 'src/content/applications/WorkflowV2/Services/Settings')));
// --- Status & Pages ---
const Overview = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/overview')));
const LoginLandingPage = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/Components/Login/LandingPage')));
const PostLoginLanding = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/Components/PostLoginLanding')));
const SignIn = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/Components/Login/SignInPage')));
const SignInPageNew = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/Components/Login/SignInPageNew')));
const PostLoginPage = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/Components/Login/PostLoginPage')));
const ForgotPassword = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/Components/Login/ForgotPasswordPage')));
const ResetPassword = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/Components/Login/ResetPasswordPage')));
const Status404 = Loader(lazy(() => import('src/content/pages/Status/Status404')));
const Status500 = Loader(lazy(() => import('src/content/pages/Status/Status500')));
const StatusComingSoon = Loader(lazy(() => import('src/content/pages/Status/ComingSoon')));
const StatusMaintenance = Loader(lazy(() => import('src/content/pages/Status/Maintenance')));

// --- UI Components / Style Guide ---
const Buttons = Loader(lazy(() => import('src/content/pages/Components/Buttons')));
const Modals = Loader(lazy(() => import('src/content/pages/Components/Modals')));
const Accordions = Loader(lazy(() => import('src/content/pages/Components/Accordions')));
const Tabs = Loader(lazy(() => import('src/content/pages/Components/Tabs')));
const Badges = Loader(lazy(() => import('src/content/pages/Components/Badges')));
const Tooltips = Loader(lazy(() => import('src/content/pages/Components/Tooltips')));
const Avatars = Loader(lazy(() => import('src/content/pages/Components/Avatars')));
const Cards = Loader(lazy(() => import('src/content/pages/Components/Cards')));
const Forms = Loader(lazy(() => import('src/content/pages/Components/Forms')));
const CommentsDemoPage = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/pages/CommentsDemoPage')));

// --- Finance & Misc Modules ---
const LoanReqest = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/LoanRequest/index')));
const AddLoanReqest = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/LoanRequest/AddLoanRequest')));
const EditLoanReqest = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/LoanRequest/EditLoanRequest')));
const ViewLoanReqest = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/LoanRequest/ViewLoanRequest')));
const SalaryAdvance = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/SalaryAdvance/index')));
const AddSalaryAdvance = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/SalaryAdvance/AddSalaryAdvance')));
const EditSalaryAdvance = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/SalaryAdvance/EditSalaryAdvance')));
const ViewSalaryAdvance = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/SalaryAdvance/ViewSalaryAdvance')));
const Expense = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/expense')));
const AddExpenseDetails = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/expense/addExpense/addExpenseDetails')));
const ViewExpense = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/expense/addExpense/viewExpense')));
const TeamExpenseView = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/expense/teamExpenseView')));

// --- Task & Checklist Management ---
const TaskRemainder = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/TaskRemainder/index')));
const AddTaskRemainder = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/TaskRemainder/addTask')));
const EditTaskRemainder = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/TaskRemainder/editTaskTickets')));
const TaskTemplate = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/TaskTemplate/index')));
const AddTaskTemplate = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/TaskTemplate/AddTaskTemplate')));
const EditTaskTemplate = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/TaskTemplate/EditTaskTemplate')));
const ViewTaskTemplate = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/TaskTemplate/ViewTaskTemplate')));
const Checklist = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/Checklist/index')));
const AddChecklist = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/Checklist/AddChecklist')));
const EditChecklist = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/Checklist/EditChecklist')));
const ViewChecklist = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/ClientTask/Checklist/ViewChecklist')));
const MediaManagement = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/mediaManagement')));

// --- Support & Maintenance ---
const DefectTracker = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/DefectTracker/index')));
const AddDefectTracker = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/DefectTracker/DefectTracketAdd')));
const EditDefectTracker = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/DefectTracker/DefectTrackerEdit')));
const ViewDefectTracker = Loader(lazy(() => import(/* webpackChunkName: "client-project-app" */ 'src/content/applications/DefectTracker/DefectTrackerView')));
const TicketTransitionTableList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Ticket Transition/index')));
const EditTicketTransition = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Ticket Transition/editTicketTransition')));
const TicketSlaList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/TicketSLA')));
const TicketClosure = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Tickettool/TicketClosure')));
const MailOptions = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/MailOptions/index')));
const AddMailOptions = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/MailOptions/AddMailOptions')));
const MenuSettings = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/MenuSettings/index')));
const ShiftTimingList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ShiftTiming/ShiftTimingList')));
const AddShiftTiming = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ShiftTiming/ShiftTimingAdd')));
const ShiftTimingEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ShiftTiming/ShiftTimingEdit')));

const TemplateManager = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Template/addTemplate')));
const ShiftSwap = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/ShiftSwapRequest')));
const AddShiftSwap = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/ShiftSwapRequest/AddShiftSwap')));

// --- Dashboards & Messenger ---
const DynamicDashboard = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/dashboardpage/DynamicDashboard')));
const DashboardByKey = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/dashboardpage/DashboardByKey')));
const Dashboard = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/dashboardpage/dashboard')));
const Messenger = Loader(lazy(() => import(/* webpackChunkName: "core-auth" */ 'src/content/applications/Messenger')));

// --- Attendance & Holiday ---
const AttendenceUpload = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/attendenceUpload')));
const AttendenceList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/attendenceLists')));
const DailyAttendance = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/DailyAttendance/DailyAttendance')));
const HolidayCalender = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/HolidayCalender')));
const ViewHolidayCalender = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/HolidayCalender/viewHolidays')));
const EditHolidayCalender = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/HolidayCalender/editHolidayCalender')));
const BuildMyHolidayCalender = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/HolidayCalender/BuildMyCalender')));
const AddHolidayCalender = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/HolidayCalender/addHoliday')));

// --- Leave Management ---
const LeaveTableList = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Leave')));
const AddLeave = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Leave/AddLeave')));
const AddTeamLeave = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Leave/AddTeamLeave')));
const ViewLeave = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Leave/ViewLeave')));
const EditLeave = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Leave/EditLeaveRequest')));
const LeaveAdjustment = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/LeaveAdjustment')));
const LeaveAdjustmentTabel = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/LeaveAdjustment/LeaveAdjustmentTabel')));
const LeaveCompOffList = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/LeaveCompOff')));
const AddCompOff = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/LeaveCompOff/addCompOff')));
const AddTeamCompOffLeave = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/LeaveCompOff/addTeamCompOff')));
const EditcompLeave = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/LeaveCompOff/editCompOff')));
const LeaveTypeList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/LeaveType')));
const LeaveTypeCreate = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/LeaveType/AddLeaveType')));
const UpdateLeaveType = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/LeaveType/UpdateLeaveType')));
const ViewLeaveType = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/LeaveType/viewLeaveType')));

// --- Shift Planning ---
const ShiftPlan = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ShiftPlan')));
const AddShiftPlan = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ShiftPlan/addShiftPlan')));
const ViewShiftPlan = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ShiftPlan/viewShiftPlan')));
const EditShiftPlan = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ShiftPlan/editShiftPlan')));
const ShiftCoverage = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/shiftCoverage')));
const AddShiftCoverage = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/shiftCoverage/addShiftCoverage')));
const ShiftCalender = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/ShiftCalender')));

// --- Worklog ---
const WorkLog = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/WorkLog')));
const TableWorklog = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/WorkLog/TableWorklog')));
const AddWorkLog = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/WorkLog/AddWorkLog')));
const ViewWorklog = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/WorkLog/ViewWorklog')));
const EditWorklog = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/WorkLog/EditWorklog')));

// --- Status Updates & Policy ---
const StatusUpdateList = Loader(lazy(() => import('src/content/applications/StatusUpdate/index')));
const AddStatusUpdate = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/StatusUpdate/addStatusUpdate')));
const ViewStatusUpdate = Loader(lazy(() => import('src/content/applications/StatusUpdate/viewStatusUpdate')));
const Policy = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Policy')));
const PolicyAdd = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Policy/AddPolicy')));
const PolicyView = Loader(lazy(() => import(/* webpackChunkName: "employee-app" */ 'src/content/applications/Policy/viewPolicy')));
const PolicyUpdateById = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Policy/UpdatePolicy')));

// --- Permissions & Roles ---
const PermissionsList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/permissionList')));
const Permissions = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/permission')));
const Permission = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Permissions')));
const Roles = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/RolesManagement/RolesListPage.tsx')));
const AddRolesManagement = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/RolesManagement/AddRolesManagement')));
const EditsRolesManagement = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/RolesManagement/AddRolesManagement'))); // This name is used in routes
const EditRolesManagement = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/RolesManagement/EditRolesManagement')));
const RoleEditV2 = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/RolesManagement/RoleEditV2')));

// Conditional component based on feature flag
const RoleEditComponent = process.env.REACT_APP_FEATURE_NEW_RBAC === 'true' ? RoleEditV2 : EditsRolesManagement;

// V2 is the default; set REACT_APP_FEATURE_EMPLOYEE_LIST_V1=true to revert to the old directory
const EmployeeListComponent = process.env.REACT_APP_FEATURE_EMPLOYEE_LIST_V1 === 'true' ? EmployeeDirectory : EmployeeListV2;

// --- System Admin ---
const SchedulerDashboard = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/SystemAdmin/SchedulerDashboard')));

// --- Settings & Configuration ---
const OrganisationProfile = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/datepage')));
const OrganisationProfileUpdate = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/organisationProfileUpdate')));
const AddWorkLocations = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/AddworkLocations')));
const WorkLocationEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/WorkLocationEdit')));
const WorkLocationList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/worklocationData')));
const AddDepartments = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/AddDepartments')));
const DepartmentsList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/departmentData')));
const EditDepartments = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/departmentEdit')));
const AddDesignation = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/AddDesignation')));
const EditDesignation = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/designationEdit')));
const DesignationList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Settings/designationData')));

// Forms Module
const FormsList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Forms/FormsList')));
const FormEditor = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Forms/FormEditor')));
const CodeReference = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/CodeReference/AddCodeReference')));
const CodeReferenceList = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/CodeReference/CodeReferenceListPage')));
const CodeReferenceEdit = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/CodeReference/UpdatecodeReference')));
const FeatureRoleAccess = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/FeatureRoleAccess')));
const AddFeatureRoleAccess = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/FeatureRoleAccess/addFeatureRoleAccess')));
const EditFeatureRoleAccess = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/FeatureRoleAccess/editFeatureRoleAccess')));
const OfferLetterGenerator = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/User-Details/Users/offerLetterGenerator')));
const AddTemplate = Loader(lazy(() => import(/* webpackChunkName: "admin-app" */ 'src/content/applications/Template/addTemplate')));




const routes: RouteObject[] = [
  {
    path: 'home',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <PostLoginLanding />
      }
    ]
  },
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: (
          <TenantAutoRedirect>
            <LoginLandingPage />
          </TenantAutoRedirect>
        )
      },
      {
        path: '/login',
        element: (
          <TenantAutoRedirect>
            <SignInPageNew />
          </TenantAutoRedirect>
        )
      },
      {
        path: '/login-old',
        element: (
          <TenantAutoRedirect>
            <SignIn />
          </TenantAutoRedirect>
        )
      },
      {
        path: '/post-login',
        element: <PostLoginPage />
      },
      {
        path: '/forget-password',
        element: (
          <TenantAutoRedirect>
            <ForgotPassword />
          </TenantAutoRedirect>
        )
      },
      {
        path: '/resetpassword/:id',
        element: <ResetPassword />
      },
      {
        path: '/t/:tenant/resetpassword/:id',
        element: <ResetPassword />
      },
      {
        path: 't/:tenantRef/*',
        element: <TenantRouteRedirect />
      },
      {
        path: 'overview',
        element: <Navigate to="/" replace />
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'dashboard',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        // element: <Navigate to="1" replace />
        element: <PostLoginLanding />

      },
      {
        path: ':id',
        element: <DynamicDashboard />
      },
      {
        path: 'by-key/:key',
        element: <DashboardByKey />
      },
      {
        path: 'messenger',
        element: <Messenger />
      },
      {
        path: 'comments-demo/:entityId?',
        element: <CommentsDemoPage />
      }
    ]
  },
  {
    path: 'workflowv2',
    element: <SidebarLayout />,
    children: [
      {
        path: 'dashboard',
        element: <WorkflowDashboard />
      },
      // {
      //   path: 'pm-dashboard',
      //   element: <PMDashboard />
      // },
      {
        path: 'board',
        element: <WorkflowBoard />
      },
      {
        path: 'tasks',
        element: <WorkflowTasksList />
      },
      {
        path: 'tasks/add',
        element: <WorkflowNewTask />
      },
      {
        path: 'tasks/:id',
        element: <WorkflowViewTask />
      },
      {
        path: 'tasks/:id/edit',
        element: <WorkflowEditTask />
      },
      {
        path: 'tasks/create-workflow',
        element: <WorkflowCreate />
      },
      {
        path: 'workflows',
        element: <WorkflowsList />
      },
      {
        path: 'workflows/:id',
        element: <ViewWorkflow />
      },
      {
        path: 'subtasks',
        element: <Navigate to="/workflowv2/tasks" replace />
      },
      {
        path: 'subtasks/add',
        element: <Navigate to="/workflowv2/tasks/add" replace />
      },
      {
        path: 'subtasks/:id',
        element: <Navigate to="/workflowv2/tasks" replace />
      },
      {
        path: 'subtasks/:id/edit',
        element: <Navigate to="/workflowv2/tasks" replace />
      },
      {
        path: 'checklists',
        element: <WorkflowChecklists />
      },
      {
        path: 'checklists/create',
        element: <WorkflowChecklistCreate />
      },
      {
        path: 'templates',
        element: <WorkflowTemplates />
      },
      {
        path: 'templates/create',
        element: <WorkflowTemplateEdit />
      },
      {
        path: 'templates/:id/edit',
        element: <WorkflowTemplateEdit />
      },
      {
        path: 'labels',
        element: <WorkflowLabels />
      },
      {
        path: 'calendar',
        element: <WorkflowCalendar />
      },
      {
        path: 'compliance/templates',
        element: <ComplianceTemplates />
      },
      {
        path: 'compliance/templates/:id',
        element: <ComplianceTemplateDetail />
      },
      {
        path: 'compliance/client-profiles',
        element: <ClientComplianceProfiles />
      },
      {
        path: 'compliance/process-bindings',
        element: <ProcessBindings />
      },
      {
        path: 'compliance/deadlines',
        element: <ComputedDeadlines />
      },
      {
        path: 'compliance/dashboard',
        element: <ClientComplianceDashboard />
      },
      {
        path: 'examples/custom-fields',
        element: <CustomFieldsExample />
      },
      // --- SOP Module Routes (NEW) ---
      {
        path: 'sop',
        element: <SOPDocuments />
      },
      {
        path: 'sop/create',
        element: <SOPCreatePage />
      },
      {
        path: 'sop/:id',
        element: <SOPViewPage />
      },
      {
        path: 'sop/:id/edit',
        element: <SOPCreatePage />
      },
      // --- Services Module Routes (NEW) ---
      {
        path: 'services',
        element: <ServiceCatalog />
      },
      {
        path: 'services/create',
        element: <ServiceForm />
      },
      {
        path: 'services/:id/edit',
        element: <ServiceForm />
      },
      {
        path: 'services/client-services',
        element: <ClientServicesPage />
      },
      {
        path: 'services/client-services/create',
        element: <ClientServiceForm />
      },
      {
        path: 'services/client-services/:id/edit',
        element: <ClientServiceForm />
      },
      {
        path: 'services/client-services/:id',
        element: <ClientServiceDetail />
      },
      {
        path: 'services/projects/:id',
        element: <ProjectDetails />
      },
      {
        path: 'services/scheduled-jobs',
        element: <ScheduledJobsPage />
      },
      {
        path: 'services/settings',
        element: <ServiceSettingsPage />
      },
      {
        path: 'services/:id',
        element: <ServiceDetail />
      }
    ]
  },

  {
    path: 'notifications',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <NotificationsPage />
      }
    ]
  },

  {
    path: 'status-update',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <StatusUpdateList />
      }
    ]
  },
  {
    path: 'add-status-update',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <AddStatusUpdate />
      }
    ]
  },
  {
    path: 'edit-status-update/:id',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <AddStatusUpdate />
      }
    ]
  },
  {
    path: 'view-status-update/:id',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <ViewStatusUpdate />
      }
    ]
  },

  {
    path: 'resignation-submission',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Resignationsubmission />
      }
    ]
  },
  {
    path: 'resignation-approval/:id',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <ResignationApproval />
      }
    ]
  },
  {
    path: 'exit-interview/:id',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <ExitInterview />
      }
    ]
  },

  {
    path: 'add-employee',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: < AddEmployeeRds />
      }
    ]
  },

  // {
  //   path: 'employee-list',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <  EmployeeList />
  //     }
  //   ]
  // },

  {
    path: 'add-resignation',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <AddResignation />
      }
    ]
  },

  {
    path: 'resignation-edit/:id',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <ResignationEdit />
      }
    ]
  },
  {
    path: 'employee',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'add',
        element: <AddEmployee />
      },
      {
        path: 'employee-details',
        element: <MyDetails />
      },
      {
        path: 'MyDetails',
        element: <MyDetailsInfo />
      },
      {
        path: 'view/:id',
        element: <Employees />
      },
      {
        path: 'profile/:id',
        element: <EmployeeProfilePage />
      }
    ]
  },
  {
    path: 'my-detail',
    element: <SidebarLayout />,
    children: [
      {
        path: 'view/:id',
        element: <MyDetail />
      }
    ]
  },
  {
    path: 'clients',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <ClientTable />
      },
      {
        path: 'AddClient',
        element: <AddClient />
      },
      {
        path: 'EditClient/:id',
        element: <AddClient />
      },
      {
        path: 'ViewClient/:id',
        element: <ClientDetails />
      },
      {
        path: ':id',
        element: <ClientDetails />
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'attendence-upload',
        element: <AttendenceUpload />
      },
      {
        path: 'attendence-lists',
        element: <AttendenceList />
      },
      {
        path: 'permissions',
        element: <PermissionsList />
      },

      {
        path: 'permissions-lists/:id',
        element: <Permissions />
      },

      {
        path: 'expense',
        element: <Expense />
      },

      {
        path: 'expense/:userExpenseId/:itemId/view',
        element: <ViewExpense />
      },
      {
        path: 'teamexpense/:userExpenseId/:itemId/view',
        element: <TeamExpenseView />
      },
      {
        path: 'add-expense-details/:actions',
        element: <AddExpenseDetails />
      },

      {
        path: 'expense/:userExpenseId/:itemId/:actions',
        element: <AddExpenseDetails />
      },

      {
        path: 'worklog',
        element: <WorkLog />
      },

      {
        path: 'workloglist/:id',
        element: <TableWorklog />
      },
      {
        path: 'addworklog',
        element: <AddWorkLog />
      },
      {
        path: 'viewworklog/:id',
        element: <ViewWorklog />
      },
      {
        path: 'editworklog/:id',
        element: <EditWorklog />
      },

      // {
      //   path: 'workloglist/:id',
      //   element: <TableWorklog />
      // },
      {
        path: 'ticket-tool/netops',
        element: <TickettoolApp />
      },

      {
        path: 'add-ticket-tool/netops',
        element: <AddTicketTool />
      },
      {
        path: 'add-ticket-tool/netops/:id',
        element: <AddTicketTool />
      },
      {
        path: 'view-ticket-tool/netops/:id',
        element: <ViewTicketTool />
      },
      {
        path: 'edit-ticket-tool/netops/:id',
        element: <EditTicketTool />
      },
      {
        path: 'ticket-tool/ticket-closure/er',
        element: <TicketClosure />
      },
      {
        path: 'ticket-tool/ticket-closure/netops',
        element: <TicketClosure />
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details',
            element: <UserProfile />
          },
          {
            path: 'settings',
            element: <UserSettings />
          }
        ]
      }
    ]
  },

  // User Profile - accessible to all signed-in users
  {
    path: 'my-profile',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <MyProfile />
      }
    ]
  },

  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'code-reference',
        element: <CodeReference />
      },

      {
        path: 'code-reference-list',
        element: <CodeReferenceList />
      },

      {
        path: 'code-reference-edit/:id',
        element: <CodeReferenceEdit />
      },

      {
        path: 'feature-role-access-list',
        element: <FeatureRoleAccess />
      },

      {
        path: 'feature-role-access',
        element: <AddFeatureRoleAccess />
      },

      {
        path: 'feature-role-access-edit/:id',
        element: <EditFeatureRoleAccess />
      },


      {
        path: 'offer-letter-generator',
        element: <OfferLetterGenerator />
      },
      {
        path: 'system-scheduler',
        element: <SchedulerDashboard />
      },

    ]
  },

  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'roles',
        element: <Roles />
      },
      {
        path: 'add-roles',
        element: <AddRolesManagement />
      },
      {
        path: 'edit-roles/:id',
        element: <RoleEditComponent />
      }
    ]
  },


  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: 'offer-letter-template',
        element: <AddTemplate />
      },
    ]
  },



  {
    path: 'media-management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <MediaManagement />
      }
    ]
  },
  // employee-list
  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'employee-list',
        element: <EmployeeListComponent />
      }
    ]
  },

  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'user-details',
        element: <UserDetails />
      },

      {
        path: 'user-list',
        element: <UserDetailsList />
      },

      {
        path: 'user-edit/:id',
        element: <UserDetailsEdit />
      },
      {
        path: 'view-user/:id',
        element: <UserView />
      },
      {
        path: 'users/new',
        element: <UserDetailPage />
      },
      {
        path: 'users/:id',
        element: <UserDetailPage />
      }
    ]
  },

  //Asset management module
  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'assetdetails/add',
        element: <AssetDetails />
      },
      {
        path: 'asset-details/list',
        element: <AssetManagementList />
      },
      {
        path: 'assetdetails/:id',
        element: <AssetDetailsEdit />
      },
      {
        path: 'assetutilize/add',
        element: <AssetUtilize />
      },
      {
        path: 'asset-utilization/list',
        element: <AssetUtilizeList />
      },
      {
        path: 'assetutilize/:id',
        element: <AssetUtilizeEdit />
      },

      {
        path: 'asset-service/add',
        element: <AssetService />
      },
      {
        path: 'asset-service/:id',
        element: <AssetSeviceEdit />
      },
      {
        path: 'asset-service/:id',
        element: <AssetSeviceEdit />
      },
      {
        path: 'asset-service/list',
        element: <AssetServiceList />
      },

      {
        path: 'asset-exitform/add',
        element: <AssetExitForm />
      },

      {
        path: 'asset-exitform/:id',
        element: <AssetExitEdit />
      },
      {
        path: 'asset-exitform/list',
        element: <AssetExitFormList />
      },
      {
        path: 'asset-profile/:assetId',
        element: <AssetProfile />
      }
    ]
  },

  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: '/ticket-transition/list',
        element: <TicketTransitionTableList />
      },

      {
        path: '/ticket-transition/edit/:id',
        element: <EditTicketTransition />
      },

      {
        path: '/shift-coverage/list',
        element: <ShiftCoverage />
      },
      {
        path: '/shift-coverage/add',
        element: <AddShiftCoverage />
      },
      {
        path: '/shift-plan/list',
        element: <ShiftPlan />
      },

      {
        path: '/add-shift-plan',
        element: <AddShiftPlan />
      },

      {
        path: '/shift-plan/view/:id',
        element: <ViewShiftPlan />
      },

      {
        path: '/shift-plan/edit/:id',
        element: <EditShiftPlan />
      },

      {
        path: '/shift-calender/list',
        element: <ShiftCalender />
      },
      {
        path: '/daily-attendance/list',
        element: <DailyAttendance />
      },

      {
        path: '/holiday-calender/list',
        element: <HolidayCalender />
      },

      {
        path: '/view-holiday-calender/:id',
        element: <ViewHolidayCalender />
      },
      {
        path: '/edit-holiday-calender/:id',
        element: <EditHolidayCalender />
      },

      {
        path: '/build-holiday-calender/:id',
        element: <BuildMyHolidayCalender />
      },

      {
        path: '/add-holiday-calender',
        element: <AddHolidayCalender />
      },

      {
        path: 'policy/list',
        element: <Policy />
      },

      {
        path: '/policy/add',
        element: <PolicyAdd />
      },

      {
        path: 'view-policy/:id',
        element: <PolicyView />
      },
      {
        path: 'edit-policy/:id',
        element: <PolicyUpdateById />
      },

      {
        path: 'leave-list',
        element: <LeaveTableList />
      },
      {
        path: 'add-leave-request',
        element: <AddLeave />
      },

      {
        path: 'view-leave/:id',
        element: <ViewLeave />
      },
      {
        path: 'edit-leave-request/:id',
        element: <EditLeave />
      },
      {
        path: 'leave-type-list',
        element: <LeaveTypeList />
      },
      {
        path: 'leave-type-create',
        element: <LeaveTypeCreate />
      },
      {
        path: 'upDate-leave-type/:id',
        element: <UpdateLeaveType />
      },
      {
        path: 'view-leave-type/:id',
        element: <ViewLeaveType />
      },
      {
        path: 'leave-adjustment',
        element: <LeaveAdjustment />
      },

      {
        path: 'permission',
        element: <Permission />
      },

      {
        path: 'leave-comp-off',
        element: <LeaveCompOffList />
      },
      {
        path: 'add-leaveCompOff',
        element: <AddCompOff />
      },
      {
        path: 'view-leaveCompOff',
        element: <ViewLeave />
      },
      {
        path: 'edit-leaveCompOff/:id',
        element: <EditcompLeave />
      },
      {
        path: 'organisationprofile',
        element: <OrganisationProfile />
      },
      {
        path: 'organisationprofile/edit/:id',
        element: <OrganisationProfileUpdate />
      },
      {
        path: 'work-locations/add',
        element: <AddWorkLocations />
      },
      {
        path: 'work-locations/edit/:id',
        element: <WorkLocationEdit />
      },
      {
        path: 'work-locations/list',
        element: <WorkLocationList />
      },
      {
        path: 'department/add',
        element: <AddDepartments />
      },
      {
        path: 'department/list',
        element: <DepartmentsList />
      },
      {
        path: 'department/edit/:id',
        element: <EditDepartments />
      },
      {
        path: 'designation/add',
        element: <AddDesignation />
      },
      {
        path: 'designation/edit/:id',
        element: <EditDesignation />
      },
      {
        path: 'designation/list',
        element: <DesignationList />
      },
      {
        path: 'forms',
        element: <FormsList />
      },
      {
        path: 'forms/new',
        element: <FormEditor />
      },
      {
        path: 'forms/:id',
        element: <FormEditor />
      },
      {
        path: 'ticket-sla/list',
        element: <TicketSlaList />
      },
      {
        path: 'mail-options-list',
        element: <MailOptions />
      },
      {
        path: 'mail-options-add',
        element: <AddMailOptions />
      },
      {
        path: `mail-options-edit/:id`,
        element: <AddMailOptions />
      },
    ]
  },

  {
    path: 'add-team-leave-request',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <AddTeamLeave />
      }
    ]
  },
  {
    path: 'add-team-comp-off-leave-request',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <AddTeamCompOffLeave />
      }
    ]
  },

  //Taskmodule
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="user" replace />
      },

      {
        path: '',
        element: <Navigate to="projects" replace />
      },
      {
        path: 'projects',
        element: <Projects />
      },
      {
        path: 'projects/:id',
        element: <AddProjects />
      },
      {
        path: 'ViewProjects/:id',
        element: <ProjectDetails />
      },
      {
        path: '',
        element: <Navigate to="tickets" replace />
      },
      {
        path: 'ticket-tool/er',
        element: <TickettoolApp />
      },

      {
        path: 'edit-ticket-tool/er/:id',
        element: <EditTicketTool />
      },

      {
        path: 'add-ticket-tool/er',
        element: <AddTicketTool />
      },
      {
        path: 'add-ticket-tool/er/:id',
        element: <AddTicketTool />
      },
      {
        path: 'view-ticket-tool/er/:id',
        element: <ViewTicketTool />
      },
      // {
      //   path: 'addusers',
      //   element: <AddUsers />
      // },
      // {
      //   path: 'users/:id',
      //   element: <AddUsers />
      // },
      {
        path: 'addprojects',
        element: <AddProjects />
      }

      // {
      //   path: 'workloglist/:id',
      //   element: <TableWorklog />
      // },
    ]
  },
  {
    path: 'defect-tracker',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'list',
        element: <DefectTracker />
      },
      {
        path: 'Add',
        element: <AddDefectTracker />
      },
      {
        path: 'Edit/:id',
        element: <EditDefectTracker />
      },
      {
        path: 'View/:id',
        element: <ViewDefectTracker />
      }
    ]
  },
  {
    path: 'tasks',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <TaskRemainder />
      },
      {
        path: 'Add',
        element: <AddTaskRemainder />
      },
      {
        path: 'Edit/:id/:ticket',
        element: <EditTaskRemainder />
      },
      {
        path: 'View/:id',
        element: <TaskRemainder />
      }
    ]
  },
  {
    path: 'task-template',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <TaskTemplate />
      },
      {
        path: 'Add',
        element: <AddTaskTemplate />
      },
      {
        path: 'Edit/:id',
        element: <EditTaskTemplate />
      },
      {
        path: 'View/:id',
        element: <ViewTaskTemplate />
      }
    ]
  },
  {
    path: 'Checklist',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <Checklist />
      },
      {
        path: 'Add',
        element: <AddChecklist />
      },
      {
        path: 'Edit/:id',
        element: <EditChecklist />
      },
      {
        path: 'View/:id',
        element: <ViewChecklist />
      }
    ]
  },

  {
    path: 'finance',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'loan-request/list',
        element: <LoanReqest />
      },
      {
        path: 'loan-request/Add',
        element: <AddLoanReqest />
      },
      {
        path: 'loan-request/Edit/:id',
        element: <EditLoanReqest />
      },
      {
        path: 'loan-request/View/:id',
        element: <ViewLoanReqest />
      },
      {
        path: 'salary-advance/list',
        element: <SalaryAdvance />
      },
      {
        path: 'salary-advance/Add',
        element: <AddSalaryAdvance />
      },
      {
        path: 'salary-advance/Edit/:id',
        element: <EditSalaryAdvance />
      },
      {
        path: 'salary-advance/View/:id',
        element: <ViewSalaryAdvance />
      }
    ]
  },

  {
    path: 'shift-swap-request',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <ShiftSwap />
      },
      {
        path: 'add',
        element: <AddShiftSwap />
      },
      {
        path: 'edit/:id',
        element: <AddShiftSwap />
      }
      // {
      //   path: 'view/:id',
      //   element: <ViewTaskTemplate />
      // }
    ]
  },

  {
    path: 'menu-settings',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <MenuSettings />
      },
      {
        path: 'Add',
        element: <MenuSettings />
      },
      {
        path: 'Edit/:id',
        element: <MenuSettings />
      },
      {
        path: 'View/:id',
        element: <MenuSettings />
      }
    ]
  },

  {
    path: 'shift-timing',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <ShiftTimingList />
      },
      {
        path: 'Add',
        element: <AddShiftTiming />
      },
      {
        path: 'Edit/:id',
        element: <ShiftTimingEdit />
      },
      {
        path: 'View/:id',
        element: <ShiftTimingList />
      }
    ]
  },


  // Client Portal - tenant-scoped routes (must come BEFORE non-scoped portal routes)
  {
    path: '/portal/t/:tenantRef/*',
    element: <TenantRouteRedirect />
  },

  // Client Portal - external client-facing routes
  {
    path: '/portal',
    element: <BaseLayout />,
    children: portalRoutes.children
  },

  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      },
      {
        path: 'buttons',
        element: <Buttons />
      },
      {
        path: 'PersonSlide',
        element: <PersonSlide />
      },
      {
        path: 'modals',
        element: <Modals />
      },
      {
        path: 'accordions',
        element: <Accordions />
      },
      {
        path: 'tabs',
        element: <Tabs />
      },
      {
        path: 'badges',
        element: <Badges />
      },
      {
        path: 'tooltips',
        element: <Tooltips />
      },
      {
        path: 'avatars',
        element: <Avatars />
      },
      {
        path: 'cards',
        element: <Cards />
      },
      {
        path: 'forms',
        element: <Forms />
      }
    ]
  }
];

export default routes;